import Http from '@rootCommon/services/http';
import { FHQ_SMS_EMAIL_INVITATION } from '@rootCommon/constants/end-points';
import { FhqInvitation, FhqInvitationSetting, FhqInvitationSettingDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';
import { ADMIN } from '@rootCommon/constants/common';

const FHQ_SMS_EMAIL_INVITATION_ADMIN = `${FHQ_SMS_EMAIL_INVITATION}/${ADMIN}`;

class FhqInvitationSettings extends Http {
  getBySiteFhqId = async (siteFhqId: IdType): Promise<FhqInvitation> => {
    const res = await Http.get<FhqInvitationSetting>(FHQ_SMS_EMAIL_INVITATION_ADMIN, {
      params: { siteFhqId },
    });

    return { siteFhqId, settings: res.data };
  };

  updateBySiteFhqId = async (siteFhqId: IdType, data: FhqInvitationSettingDto): Promise<FhqInvitation> => {
    const res = await Http.put<FhqInvitationSetting, FhqInvitationSettingDto>(
      FHQ_SMS_EMAIL_INVITATION_ADMIN,
      data,
      {
        params: { siteFhqId },
      },
    );

    return { siteFhqId, settings: res.data };
  };
}

export default new FhqInvitationSettings();
